
export default {
  layout: 'default-without-footer',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    console.error('error', this.error);
  },
  head () {
    const title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError;
    return {
      title,
    };
  },
};
